import React, { Component } from "react";
import { Alert } from "react-bootstrap";

import "./style.css";

class SP_LWOCrypt extends Component {
    constructor() {
        super();

    }

    render() {
        return (
            <Alert style={{ width: '100%', cursor: 'pointer', }} variant="light">
                <div onClick={this.props.blockSP_LWOCryptIsOpen ? this.props.closeBlockSP_LWOCrypt : this.props.openBlockSP_LWOCrypt}
                    style={{ display: "flex", borderBottom: this.props.blockSP_LWOCryptIsOpen ? "1px solid #e3e3e3" : null, height: this.props.blockSP_LWOCryptIsOpen ? "40px" : null /*cursor: "pointer"*/ }}>
                    <div style={{ width: "55%" }}>
                        <div style={{ color: "black" }}>ПК LWOCrypt</div>

                    </div>
                    <div style={{ width: "45%" }}>
                        <b style={{ color: "black", float: "right" }}>
                            {this.props.blockSP_LWOCryptIsOpen ?
                                <div >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" fill="none"><path d="M12.25.438H1.75a.881.881 0 00-.875.875v.875c0 .492.383.874.875.874h10.5a.881.881 0 00.875-.874v-.876a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg>
                                </div> :
                                <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none"><path d="M12.25 5.438H8.312V1.5a.9.9 0 00-.874-.875h-.875a.881.881 0 00-.875.875v3.938H1.75a.881.881 0 00-.875.875v.875c0 .492.383.875.875.875h3.938V12c0 .492.382.875.875.875h.875A.881.881 0 008.313 12V8.062h3.937a.881.881 0 00.875-.874v-.875a.9.9 0 00-.875-.875z" fill="#1A3967" /></svg></div>
                            }
                        </b>
                    </div>

                </div>
                {
                    this.props.blockSP_LWOCryptIsOpen ?
                        <div className="sp-lwocrypt-block ">
                            <p>
                                ПК LWOCRYPT предназначен для выполнения следующих криптографических
                                функций:
                            </p>

                            <ul>
                                <li>
                                    формирования запроса на получение сертификата в соответствии с требованиями
                                    СТБ 34.101.17-2012 «Информационные технологии и безопасность;
                                </li>
                                <li>
                                    верификации маршрута сертификации согласно требованиям СТБ 34.101.19-2012
                                    «Информационные технологии и безопасность;
                                </li>
                                <li>
                                    использования синтаксиса криптографических сообщений согласно
                                    требованиям СТБ 34.101.23-2012 «Информационные технологии и безопасность.
                                    Синтаксис криптографических сообщений»;
                                </li>
                                <li>
                                    проверки статуса сертификата (онлайн) согласно требованиям СТБ 34.101.26-2012
                                    «Информационные технологии и безопасность. Онлайновый протокол проверки статуса
                                    сертификата (OCSP)»;
                                </li>
                                <li>
                                    генерации случайных чисел согласно требованиям СТБ 34.101.27-2011 «Информационные
                                    технологии и безопасность. Требования безопасности к программным средствам
                                    криптографической защиты информации»;
                                </li>
                                <li>
                                    верификации маршрута сертификации согласно требованиям СТБ 34.101.19-2012
                                    «Информационные технологии и безопасность.
                                </li>
                                <li>
                                    шифрования данных, выработки имитовставки, аутентифицированного шифрования данных, хэширования, расширения ключа,
                                    преобразования ключа  в соответствии с требованиями СТБ 34.101.31-2020
                                    «Информационные технологии и безопасность. Алгоритмы шифрования и контроля
                                    целостности»;
                                </li>
                                <li>
                                    генерации и проверки ключей, генерации одноразового личного ключа, выработки и проверки электронной цифровой подписи (ЭЦП),
                                    транспорта ключа, парольной защиты личного ключа,
                                    использования стандартных наборов параметров эллиптической кривой,
                                    использования модуля абстрактно-синтаксической
                                    нотации версии 1  в соответствии с требованиями СТБ 34.101.45-2013
                                    «Алгоритмы электронной цифровой подписи и транспорта ключа на основе эллиптических
                                    кривых»;
                                    выработки имитовставки в режиме HMAC, генерации псевдослучайных
                                    чисел в режиме счетчика и в режиме HMAC согласно требованиям
                                    СТБ 34.101.47-2017 «Информационные технологии и безопасность. Криптографические
                                    алгоритмы генерации псевдослучайных чисел»;
                                </li>
                                <li>
                                    установления протокола защиты транспортного (коммуникационного) уровня в
                                    соответствии с требованиями СТБ 34.101.65-2014 «Информационные технологии и
                                    безопасность. Протокол защиты транспортного уровня (TLS)» (криптонаборы:
                                    <ul >
                                        <li style={{ listStyleType: 'none' }}>
                                            &#8211; TLS_DHE_BIGN_WITH_BELT_CTR_MAC_HBELT;
                                        </li>
                                        <li style={{ listStyleType: 'none' }}>
                                            &#8211; TLS_DHE_BIGN_WITH_BELT_DWP_HBELT;
                                        </li >
                                        <li style={{ listStyleType: 'none' }}>
                                            &#8211; TLS_DHT_BIGN_WITH_BELT_CTR_MAC_HBELT;
                                        </li>
                                        <li style={{ listStyleType: 'none' }}>
                                            &#8211; TLS_DHT_BIGN_WITH_BELT_DWP_HBELT;
                                        </li>
                                        <li style={{ listStyleType: 'none' }}>
                                            &#8211; TLS_DHE_PSK_BIGN_WITH_BELT_CTR_MAC_HBELT;
                                        </li>
                                        <li style={{ listStyleType: 'none' }}>
                                            &#8211; TLS_DHE_PSK_BIGN_WITH_BELT_DWP_HBELT;
                                        </li>
                                        <li style={{ listStyleType: 'none' }}>
                                            &#8211; TLS_DHT_PSK_BIGN_WITH_BELT_CTR_MAC_HBELT;
                                        </li>
                                        <li style={{ listStyleType: 'none' }}>
                                            &#8211; TLS_DHT_PSK_BIGN_WITH_BELT_DWP_HBELT);
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    хэширования в соответствии с требованиями СТБ 34.101.77-2020 «Информационные
                                    технологии и безопасность. Криптографические алгоритмы на основе sponge-функции»
                                    (при l=128, 192, 256);
                                </li>
                                <li>
                                    формирования запроса на получение сертификата, сертификата открытого
                                    ключа, списка отозванных сертификатов (СОС),
                                    подписанных данных, конвертованных данных, запроса и
                                    ответа OCSP и установления программного интерфейса в
                                    соответствии с требованиями СТБ 34.101.78-2019 «Информационные технологии и
                                    безопасность. Профиль инфраструктуры открытых ключей».
                                </li>
                            </ul>

                        </div> : null
                }

            </Alert>
        );
    }
}

export default SP_LWOCrypt;
